var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart',{staticClass:"chart",attrs:{"with-percentage":"","styles":_vm.myStyles,"options":_vm.options,"chart-data":_vm.chartData,"show-label":false,"before-draw-callback":_vm.beforeDrawCallback}})
}
var staticRenderFns = []

export { render, staticRenderFns }